module.exports = __webpack_public_path__ + "static/media/ol.58cf1796.svg";